const en = {
  /**
   * Genereal
   */
  general: {
    back: 'back',
    error:
      'An unforeseen error has occured. We have been informed and will investigate on this.',
    next: 'next',
    logout: 'logout',
    country: 'country',
    countries: {
      aut: 'Austria',
      bel: 'Belgium',
      ch: 'Switzerland',
      de: 'Germany',
      dk: 'Denmark',
      es: 'Spain',
      fr: 'France',
      irl: 'Ireland',
      it: 'Italy',
      lux: 'Luxembourg',
      nl: 'Netherland',
      nor: 'Norway',
      pol: 'Polamd',
      pt: 'Portugal',
      swe: 'Sweden',
      uk: 'United Kingdom',
    },
  },
  /**
   * Hero
   */
  hero: {
    title: 'Discover new clubs and bars around the world',
    subtitle:
      ' connects people with similar music interests worldwide and helps you to find clubs and bars that suit you',
    navigation: {
      cta: 'Become tester',
      about: 'About',
      features: 'Features',
      feedback: 'Feedback',
    },
  },
  /**
   *  usersQuotes
   */
  usersQuote: {
    julia:
      'Hey cool, I actually like going there in Hamburg [Große Freiheit, kleinraumdisco].',
    clara:
      'My friends were thrilled and most of them immediately came up with a situation in which they could have used the app well.',
    leah: 'Oh yes, I was there a while ago, that was really cool!',
    cosmo:
      'Finally a perfect way to find the right club after long searches across the internet and apps',
  },
  /**
   * About
   */
  about: {
    title: 'About {logo}',
    text:
      'The app connects you with people with similar music interests worldwide and helps you in your search for suitable clubs and bars. And not only that, you can also find people in your own city who are on the same wavelength with you. Because nothing connects us with other people more than our taste in music!',
    button: 'The whole story',
  },
  /**
   * Features
   */
  features: {
    title: 'How {logo} works',
    text:
      'Do you want to know which are your top 3 clubs in Europe? Then log in now with Spotify! If you just want to see how the app works, go ahead without login.',
    yourTop: 'Other than {clubs}, you might also like {city}:',
    withLogin: 'Login now',
    withoutLogin: 'Go on without login',
    withLoginWizard: {
      step1:
        'First, I need a few of your favorite clubs and bars in your hometown. The information is saved and helps other users with their suggestions.',
      step2:
        'First, I need a few of your favorite clubs and bars in your hometown. The information is saved and helps other users with their suggestions.',
      step3:
        'Already now, you can then search in 20 major European cities and receive suggestions from over 2,600 clubs and bars. An algorithm compares your most-heard bands and genres with the followers of the clubs and bars, or bands that played here last.',
      step4:
        'On a map, you can see where to clubs are located and get additional infos. What kind of music you can expect here is based on what users follow these clubs/bars and which bands played here.',
      step5:
        "If you don't feel like going out alone, then make yourself visible for 48 hours to everyone else who has just done it in the city.",
      step6:
        "After a mutual match, you can then write yourself via the app. You can influence how exactly the matching function works. How? Register below as a tester and I'll tell you more.",
      noResults:
        'Here are no results yet, I am working hard to find you some :)',
      fewResults:
        'Here are no other results yet, I am working hard to find you some :)',
      city: 'Hometown',
      club: 'Favourite club',
      bar: 'Favourite bar',
    },
  },
  /**
   * Feedback
   */
  feedback: {
    title: 'What users say about {logo}',
  },
  /**
   * Contact
   */
  contact: {
    title: 'Are you curious?',
    text:
      'Get in touch with us as a tester. All you need is a Spotify account!',
    name: 'Name',
    email: 'Email',
    send: 'Send',
    modal: {
      title: 'Hey, thanks!',
      both:
        'I will get back to you as soon as possible and add you as a tester. I will send you everything else in an email.',
      ios:
        'I will get back to you as soon as possible and add you as a tester. I will send you everything else in an email.',
      android:
        'I will get back to you as soon as possible and add you as a tester. I will send you everything else in an email.',
    },
  },
  /**
   * Footer
   */
  footer: {
    imprint: 'Imprint',
    privacy: 'Privacy',
  },
};

export default en;
